<template>
	<div style="position: absolute;top: 2px;right: 4px;">
		<van-tag type="danger" v-if="value===0" @click="dataflow">未结束</van-tag>
		<van-tag type="success" v-if="value===1" @click="dataflow">已结束</van-tag>
		<van-tag v-if="value===2">无流程</van-tag>
		<van-tag type="primary" v-if="value===-1">保存待发</van-tag>
		<flowdetail-index v-if="row" ref="flowdetailIndex" :dataid="row.id" :moduleName="moduleName"
			@retrieve="retrieve" />
	</div>
</template>

<script>
	import inputBase from '@_system/components/base/input.js'
	import selectBase from '@_system/components/base/select.js'
	import flowdetailIndex from './flowdetail/index.vue'
	export default {
		mixins: [inputBase, selectBase],
		props: {
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			column: {
				type: Object,
				default: () => {
					return null
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				flowdetail: false,
				content: ''
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {
			socketTimestamp() {
				let message = this.$store.state.system.websocketMessage
				if (message.event == 'NOTICE') {
					if (message.data.module == this.moduleName && message.data.dataid == this.row.id) {
						this.table.$parent.commitProxy('query')
					}
				}
			}
		},
		computed: {
			socketTimestamp() {
				return this.$store.state.system.socketTimestamp
			},
			valuetext() {
				if (this.value == 0) {
					return '未结束'
				} else if (this.value == 1) {
					return '已结束'
				} else if (this.value == 2) {
					return '无流程'
				} else if (this.value == -1) {
					return '保存待发'
				} else {
					return ''
				}
			}
		},
		methods: {
			dataflow(e) {
				e.stopPropagation()
				this.$refs.flowdetailIndex.modal_show()
			},
			edit() {
				this.$api.flowprogress.list({
					dataid: this.row.id,
					formname: this.moduleName,
					isdraft: 1
				}).then((e) => {
					let query = {
						name: this.moduleName,
						controlltype: 2,
						id: this.row.id,
						windowName: e.title,
						isflow: 1,
						flowprogressid: e.id
					}
					let res = this.$router.resolve({
						name: 'update',
						query: query
					})
					let win = window.open(res.href, this.moduleName + 'update',
						this.$store.state.system.windowConfig)
					win.location.reload(true)
				}, () => {

				})
				// let query = {
				// 	name: this.moduleName,
				// 	controlltype: 2,
				// 	id: this.row.id,
				// 	windowName: '测试',
				// 	isflow: 1,
				// 	flowprogressid: 352
				// }


			},
			formBack() {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
				}
			},
			retrieve() {
				this.$confirm('是否确认取回', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.module.retrieve(window.config.app, this.moduleName, {
						id: this.row.id
					}).then(() => {
						this.flowdetail = false
						this.table.$parent.customreload()
					})
				}).catch(() => {
					this.table.$parent.commitProxy('query')
				});


			}
		},
		components: {
			flowdetailIndex
		}
	}
</script>